module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-4 pb-0 lighten-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('v-card-title', [_vm._v(_vm._s(_vm.spefuxe.length) + " Spefüxe zum WS 2024/25")])], 1), _vm._v(" "), _c('v-expansion-panel-content', [_vm._l((_vm.spefuxe), function(item, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', {
      staticClass: "px-0 pb-0 pt-1"
    }, [_c('v-list', {
      attrs: {
        "two-line": "",
        "width": "100%"
      }
    }, [_c('v-list-item', {
      staticClass: "font-weight-bold"
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$filters.user(item.id, _vm.spefuxe)))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.studiengang))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n            " + _vm._s(item.bemerkungen) + "\n          ")])], 1)
  }), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 pb-0 pt-1"
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "width": "100%"
    }
  }, [_c('v-list-item', {
    staticClass: "font-weight-bold"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Aktuelle Füxe (" + _vm._s(_vm.fuxe.length) + ")")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.fuxe), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$filters.user(item.id, _vm.fuxe)) + "\n            ")])
  }), 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a12c8aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/home/cardHomeKeilliste.vue
// module id = 773
// module chunks = 15